<div class="pwa-container">
    <div mat-dialog-title class="pwa-container__header">
        <span>Install APK</span>
        <span class="material-icons pwa-container__header__close-btn" (click)="pwaService.closePwa()">close</span>

    </div>
    <div mat-dialog-content class="pwa-container__content" [class.ios]="pwaService.modalPwaPlatform === 'IOS'">

        <button class="red-button" *ngIf="pwaService.modalPwaPlatform === 'ANDROID'"
            (click)="pwaService.addToHomeScreen(); pwaService.closePwa()">
            Install
        </button>
        <div *ngIf="pwaService.modalPwaPlatform === 'IOS'">
            To install this WEB app on your device, tap the "Menu" button and then "Add to home screen" button
        </div>
        <button (click)="pwaService.closePwa()" class="white-button">{{ pwaService.modalPwaPlatform === 'IOS' ? 'Got it' : 'Not now' }}</button>
    </div>
</div>